/**
 * Permet de récupérer un availability-date avec les données produit à partir d'un handle défini de manière asynchrone
 * (cas des app de recherche ou de facettes)
 */
class AvailabilityBlock extends HTMLElement {
    /* Track data-product-handle changes */
    static get observedAttributes() {
        return ["data-product-handle"];
    }

    attributeChangedCallback(name, oldValue, newValue) {

        if (newValue)
            this.url = newValue;

        this.getProductInfos(newValue);

    }

    /* Inject data */
    async getProductInfos(url) {
        const html = await fetch(url + "/?sections=availability-wrapper")
            .then((response) => response.json());

        const div = document.createElement("div");
        div.innerHTML = html["availability-wrapper"];
        this.append(div);

    }

}

customElements.define('availability-block', AvailabilityBlock);


/*Affichage date */
class AvailabilityDate extends HTMLElement {

    constructor() {

        super();
        // propriétés fiches produit
        this.productRef = this.getAttribute("product-ref");
        this.variantRef = this.getAttribute("variant-ref");
        this.displayButton = this.getAttribute("display-button");
        this.currentVariant = this.getAttribute("current-variant");

        // si on est pas sur une fifche produit on affiche simpelment la date
        if (!this.variantRef)
            this.style.display = 'flex'

        this.setDisplay();

    }

    /* Track data-product-handle changes */
    static get observedAttributes() {
        return ["current-variant"];
    }

    attributeChangedCallback(name, oldValue, newValue) {

        switch (name) {
            case "current-variant"    :

                this.currentVariant = this.getAttribute("current-variant");
                this.setDisplay();

                break;
        }
    }

    // Selectionne la date à afficher et affiche le bouton acheter en focntion du variant selectionné
    setDisplay() {

        const buyButtons = document.querySelectorAll(`[availability-display="${this.productRef}"], [availability_display="${this.productRef}"]`)

        if (this.currentVariant === this.variantRef) {

            this.style.display = 'flex';
            const display = this.displayButton === "true" ? 'block' : 'none'

            buyButtons.forEach(button => {
                button.style.display = display;
            })

        } else {
            this.style.display = 'none';
        }
    }
}

customElements.define('availability-date', AvailabilityDate);

// récupoère le paramètre href des élements dynamqiues
class AvailabilityTarget extends HTMLElement {

    constructor() {
        super();

        /* Nf : update webcomponent*/
        const a = this.querySelector('[data-product-title]');
        const url = a.getAttribute("href");

        if (!url)
            return;

        /* Nf : update webcomponent*/
        const handle = this.querySelector('[data-product-handle]');
        const handleUrl = url.replace(/\?variant=\d+/, "");
        handle.setAttribute('data-product-handle', handleUrl);

    }

}

customElements.define('availability-target', AvailabilityTarget);


/**
 * Se place sur le champ input du product form qui est mis à jour lors de la sélection d'un variant
 *    <input is="availability-referer" product-ref="{{ product.id }}" type="hidden" disabled name="id" value="{{ product.selected_or_first_available_variant.id }}">
 * Permet de mettre à jour les availability-dates concernés
 */
class AvailabilityReferer extends HTMLInputElement {

    constructor() {
        super();
        this.productRef = this.getAttribute("product-ref");
    }
    /* Track data-product-handle changes */
    static get observedAttributes() {
        return ["value"];
    }

    attributeChangedCallback(name, oldValue, newValue) {

        if (newValue)
        {
        this.propagate(newValue);
        }


    }

    /* Inject data */
     propagate(newValue) {

        const targets = document.querySelectorAll(`availability-date[product-ref="${this.productRef}"]`)
        targets.forEach( elem => {
            elem.setAttribute('current-variant', newValue);
        })

    }

}

customElements.define('availability-referer', AvailabilityReferer, {extends: 'input'});


// js/custom-element/section/product/payment-container.js
var PaymentContainer = class extends HTMLElement {
    constructor() {
        super();
        this._onVariantChanged()
    }

    connectedCallback() {
        var _a;
        (_a = document.getElementById(this.getAttribute("form-id"))) == null
            ? void 0
            : _a.addEventListener(
                "variant:changed",
                this._onVariantChanged.bind(this)
            );
        if (Shopify.designMode && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
        }
    }
    _onVariantChanged(event) {
        let id
        if (event)
            id = event.detail.variant.id
        else
            id = document.querySelector(`availability-date[current-variant]`).getAttribute("current-variant");

            // Nf : permet de s'assurer de l'execution des autres web-components dans la page
        setTimeout ( () => {
            const availabilityReferer = document.querySelector(`availability-date[variant-ref="${id}"]`)
            const availabilityAddToCart = availabilityReferer.getAttribute('display-button');
            this._updateAddToCartButton(/*event.detail.variant, */availabilityAddToCart);
            this._updateDynamicCheckoutButton(/*event.detail.variant, */availabilityAddToCart);
        }, 0)
    }
    _updateAddToCartButton(/*variant,*/ forceAddtoCart) {
        let addToCartButtonElement = this.querySelector(
            "[data-product-add-to-cart-button]"
        );
        if (!addToCartButtonElement) {
            return;
        }
        let addToCartButtonText = "";
        addToCartButtonElement.classList.remove(
            "button--primary",
            "button--secondary",
            "button--ternary"
        );
     /*   if (!variant) {
            addToCartButtonElement.setAttribute("disabled", "disabled");
            addToCartButtonElement.classList.add("button--ternary");
            addToCartButtonText =
                window.themeVariables.strings.productFormUnavailable;


        } else {*/
            if (/*variant["available"] ||*/ forceAddtoCart === "true") {
                addToCartButtonElement.removeAttribute("disabled");
                addToCartButtonElement.classList.add(
                    addToCartButtonElement.hasAttribute("data-use-primary")
                        ? "button--primary"
                        : "button--secondary"
                );
                addToCartButtonText = addToCartButtonElement.getAttribute(
                    "data-button-content"
                );
            } else {
                addToCartButtonElement.setAttribute("disabled", "disabled");
                addToCartButtonElement.classList.add("button--ternary");
                addToCartButtonText =
                    window.themeVariables.strings.productFormSoldOut;
            }
       /* }*/
        if (addToCartButtonElement.getAttribute("is") === "loader-button") {
            const firstElementChild = addToCartButtonElement.querySelector(".loader-button__text");
           if (firstElementChild)
               firstElementChild.innerHTML =                addToCartButtonText;
        } else {
            addToCartButtonElement.innerHTML = addToCartButtonText;
        }
    }
    _updateDynamicCheckoutButton(/*variant,*/ forceAddtoCart) {
        let paymentButtonElement = this.querySelector(".shopify-payment-button");
        if (!paymentButtonElement) {
            return;
        }
        paymentButtonElement.style.display =
            forceAddtoCart==="false"? "none" : "block";
          //  !variant || !variant["available"] ? "none" : "block";
    }
};
window.customElements.define("product-payment-container", PaymentContainer);
